import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Sc3FailedTransactionMessageState } from './sc3-failed-transaction-message.state';
import { FailedTransactionMessageFacadeInterface } from '../../models';
import {
  Sc3FailedTransactionMessageInitialState,
  Sc3FailedTransactionMessageLoad,
} from './sc3-failed-transaction-message.actions';

@Injectable({ providedIn: 'root' })
export class Sc3FailedTransactionMessageFacade implements FailedTransactionMessageFacadeInterface {
  failedTransactionMessage$: Observable<string> = this.store.select(
    Sc3FailedTransactionMessageState.getSc3FailedTransactionMessage,
  );
  loaded$: Observable<boolean> = this.store.select(Sc3FailedTransactionMessageState.getLoaded);

  constructor(private store: Store) {}

  loadFailedTransactionMessage(rawMessageId: string): void {
    this.store.dispatch(new Sc3FailedTransactionMessageLoad(rawMessageId));
  }

  setInitialState(): void {
    this.store.dispatch(new Sc3FailedTransactionMessageInitialState());
  }
}
